import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ComponentBase, EventLyteFormsModule, FieldLabel } from '@eventlyte/forms';
import { EventLyteRegistrationModule } from '@eventlyte/registration';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCalendar, faClock, faLocationDot, faTag } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';

@Component({
	selector: 'app-registration-confirmation-badge',
	standalone: true,
	imports: [
		EventLyteFormsModule,
		EventLyteRegistrationModule,
		FontAwesomeModule,
		TranslocoDirective,
		TranslocoPipe,
		FieldLabel
	],
	templateUrl: './registration-confirmation-badge.html'
})
export class RegistrationConfirmationBadge extends ComponentBase {
	protected readonly icons = { faTag, faCalendar, faClock, faLocationDot };
	protected formGroup = new FormGroup({});

	public title = input.required<string>();
	public record = input.required<Record<string, any>>();
	public cardNumberLabel = input.required<string>();
	public fullNameLabel = input.required<string>();
	public countryLabel = input.required<string>();
	public showCountry = input<boolean>(false);
	public barcodeWidth = input<number>(140);

	protected getRecordValue(record: any, key: string): any | undefined {
		return record()[key];
	}

	protected setRecordValue(record: any, key: string, value: unknown | undefined): void {
		// Ignore as part of generator
	}

	protected isConfirmed(): boolean {
		return (
			this.record()!['registrationStatus']?.value === 'Confirmed' ||
			this.record()!['registrationStatus']?.value === 'Success'
		);
	}

	protected getFullName(): string {
		return `${this.getRecordValue(this.record, 'firstName')} ${this.getRecordValue(this.record, 'lastName')}`.trim();
	}
}
